import SideScrollList from '@components/common/SideScrollList/SideScrollList';
import HotelCardFavorite from '@components/HotelCard/HotelCardFavorite';
import styles from '@components/UserBookings/UserBookings.module.css';
import React from 'react';

type Props = {
  userFavoritesMetadata: any;
  setUserFavoritesIds: any;
  userFavoritesIds: any;
};

export default function Favorites({
  userFavoritesMetadata,
  setUserFavoritesIds,
  userFavoritesIds,
}: Props) {
  return (
    <SideScrollList
      classes={`bg-white w-full flex justify-start flex-col ${
        window.location.href.includes('bookings') ? 'overflow-x-hidden' : styles.sideScrollList
      }`}
    >
      {userFavoritesMetadata &&
        Object.keys(userFavoritesMetadata).length > 0 &&
        userFavoritesIds.map((hotelKey: any, index: number) => (
          <HotelCardFavorite
            key={
              userFavoritesMetadata[hotelKey]?.id ||
              Object.keys(userFavoritesMetadata)[index] ||
              index
            }
            hotel={userFavoritesMetadata[hotelKey]}
            userFavoritesIds={userFavoritesIds}
            setUserFavoritesIds={setUserFavoritesIds}
          />
        ))}
    </SideScrollList>
  );
}
